import React, { ComponentProps, CSSProperties } from "react";
import styled from "styled-components";
import Typography from "../../Foundation/Typography/Typography";

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: "vertical" | "horizontal";
  size?: number;
  weight?: number;
  mt?: CSSProperties["marginTop"];
  mb?: CSSProperties["marginBottom"];
  text?: string;
  color?: string;
  opacity?: CSSProperties["opacity"];
  className?: string;
}

const DividerStyled = styled("div")<DividerProps>(
  ({
    direction = "vertical",
    size,
    weight = 2,
    mt,
    mb,
    color = "#E8E8E8",
    opacity,
    text,
  }) => {
    const hasText = !!text;
    const length = size ? size : "100%";
    const fat = weight;
    const width = direction === "vertical" ? fat : length;
    const height = direction === "vertical" ? length : fat;
    const heightWithMargin =
      // @ts-expect-error
      height > 0 ? height + (mt || 0) + (mb || 0) : height;
    const pseudoSelection = `&::before${hasText && ",&::after"}`;
    return {
      display: "flex",
      flexDirection: direction === "vertical" ? "column" : "row",
      alignItems: hasText ? "center" : undefined,
      [pseudoSelection]: {
        content: '""',
        display: "block",
        width,
        height,
        backgroundColor: color,
      },
      marginBottom: mb,
      marginTop: mt,
      width,
      backgroundColor: !hasText ? color : "transparent",
      height: hasText ? heightWithMargin : height,
      // heightWithMargin,
      position: "relative",
      opacity,
      ...(!hasText && {
        marginBottom: mb,
        marginTop: mt,
      }),
    };
  }
);

const Divider = (props: DividerProps) => {
  const { ...rest } = props;
  const { text, color } = props;
  return (
    <DividerStyled {...rest}>
      {text && (
        <Typography
          style={{
            padding: "0 15px",
            ...(color && { color }),
          }}
          variant="body2"
          color={"greyText"}
        >
          {text}
        </Typography>
      )}
    </DividerStyled>
  );
};

export default Divider;
